import React from "react";

interface IconProps {
    active?: boolean;
    size?: number;
}

/** Sidebar section icon — stroke style shared with the mobile tab bar. */
const IconItems: React.FC<IconProps> = ({ active = false, size = 24 }) => {
    const color = active ? "#0F7679" : "#6A7878";
    return (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 6l7-3.5 7 3.5v9l-7 3.5-7-3.5z"/><path d="M3 6l7 3.5 7-3.5M10 9.5v9"/>
        </svg>
    );
};

export default IconItems;
